import React from 'react';
import { Button } from 'semantic-ui-react';

import styles from './styles.module.scss';

const Botao = (props) => {
    const { clique, className, ...propriedades } = props;

    return <Button className={[className, styles.btnAvancar].join(' ')} {...propriedades} onClick={clique} />;
};

export default Botao;
